import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalComponent } from './local.component';
import { NiceLegalTextModule } from '../../nice-legal-text/nice-legal-text.module';
// import { DialogModule } from '@schoolbelle/common/dialog';

@NgModule({
  declarations: [LocalComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    NiceLegalTextModule, 
    // DialogModule,
  ],
  exports:[LocalComponent],
})
export class LocalModule { }
